import { Directive, OnInit, Optional, Self } from '@angular/core';
import { Table } from 'primeng/table';

@Directive({
    selector: 'p-table'
})
export class TableResponsiveDirective implements OnInit {
    constructor(@Optional() @Self() private table: Table) { }

    ngOnInit() {
        if (this.table) {
            if (!this.table.responsiveLayout) {
                this.table.responsiveLayout = 'scroll';
            }
        }
    }
}
